import { Weight } from 'careit';
import { capitalize } from 'lodash';
import { useFoodTypes } from 'src/constants';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import PopoverFoodTypes from 'src/components/PopoverFoodTypes';
import { fNumber } from 'src/utils/formatNumber';

export const formatPartialWeight = ({ item, foodTypes }) => {
  return `${capitalize(
    foodTypes.find((f) => f.value === item.food_type).title
  )} - ${fNumber(
    new Weight(item.partial_weight_reserved || 0, 'lbs').asRounded(
      item.weight_unit
    )
  )} ${item.weight_unit}`;
};

const usePartialRescueColumns = () => {
  const { t } = useTranslation('translation');
  const foodTypes = useFoodTypes();
  return [
    {
      field: 'partial_food_types',
      headerName: t('donations.weights'),
      width: 200,
      sortable: false,
      renderCell: (params) => {
        const weights = JSON.parse(params.value || '[]');
        return params.row?.is_partial ? (
          <Stack
            alignItems={weights.length == 1 ? 'start' : 'center'}
            width="100%"
            justifyContent="center"
          >
            {params.row.available_amount ? (
              formatPartialWeight({
                item: {
                  food_type: params.row.available_food_type,
                  partial_weight_reserved: params.row.available_amount,
                  weight_unit: params.row.available_food_type_unit,
                },
                foodTypes,
              })
            ) : (
              <PopoverFoodTypes weights={JSON.parse(params.value) || []} />
            )}
          </Stack>
        ) : (
          t('common.na')
        );
      },
    },
  ];
};

export default usePartialRescueColumns;
